import React from 'react';
import SynchronizedHome from '../components/SynchronizedHome';

export default function Home() {
  return <SynchronizedHome />;
}
